__turbopack_context__.v({
  "className": "roboto_mono_c64755d2-module__wZQpGq__className",
});
